import { render, staticRenderFns } from "./TepAutorizacionIndex.vue?vue&type=template&id=481edae9"
import script from "./TepAutorizacionIndex.vue?vue&type=script&lang=js"
export * from "./TepAutorizacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports